import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { catchError, map } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs';
import jwtDecode from 'jwt-decode';

import { CEUMA_URL_AUTH_API, CEUMA_URL_API,  } from 'app/config';

import { Contratante } from 'models/contratante';
import { User } from 'models/user';

// ******* VALOR COMENTADO PARA TESTE LOCAL ******
const AUTH_API_URL = CEUMA_URL_AUTH_API + '/login';
//const AUTH_API_URL = CEUMA_URL_AUTH_API + '/loginBirthDate';
const AUTH_API_URL_RECUPERAR_SENHA = CEUMA_URL_AUTH_API + '/recuperarSenha';
const RESET_PASSWORD_API_URL = CEUMA_URL_API + '/recuperarSenha/';

@Injectable()
export class AuthenticationService {

  private loggedUser;

  constructor(private http: HttpClient) { }

  private _setLoggedUser(accessToken, tipoLogin) {
    
    if (accessToken) {
      const user = this.decodeAcessToken(accessToken);
      if (tipoLogin === 'CONTRATANTE') {
        this.loggedUser = new Contratante(user);
      } else if (tipoLogin === 'GLOBAL') {
        this.loggedUser = new User(user);
      }
      localStorage.setItem('access_token', accessToken);
      localStorage.setItem('logged_user', JSON.stringify(this.loggedUser));
    }
  }

  isUserAuthenticated(): boolean {
    const user = this.getLoggedUser();
    if (user && user.exp) {
      const currentDate = new Date().getTime();
      const expiryDate = user.exp * 1000;
      return currentDate < expiryDate;
    }
    return false;
  }

  decodeAcessToken(accessToken) {
    return jwtDecode(accessToken);
  }

  getLoggedUser(): User {
    if (!this.loggedUser) {
      const userJson = localStorage.getItem('logged_user');
      this.loggedUser = userJson ? new User(JSON.parse(userJson)) : null;
    }
    return this.loggedUser;
  }

  removeLoggedUser() {
    this.loggedUser = null;
    localStorage.removeItem('logged_user');
    localStorage.removeItem('access_token');
  }

  getAcessToken() {
    return localStorage.getItem('access_token');
  }

  login({ username, password, tipoLogin, siglaSistema, contexto}): Observable<any> {
    return this.http.post(AUTH_API_URL,
      {
        username,
        password,
        siglaSistema,
        tipoLogin,
        contexto,
      },
    ).pipe(
      map(data => {
        this._setLoggedUser((data as any).mensagem, tipoLogin);
        return this.loggedUser;
      }),
      catchError(error => observableThrowError({msg: error.error.humanMessage})),
    );
  }

  logoff(): void {
    this.removeLoggedUser();
  }

  resetPassword(cpf, email,contexto, tipoRecSenha, siglaSistema) {
    switch(tipoRecSenha){
      case 'CONTRATANTE':
        return this.http.post(AUTH_API_URL_RECUPERAR_SENHA,
          {
            cpf: cpf,
            email: null,
            cpd: email,
            contexto: contexto,
            tipoRecSenha: tipoRecSenha,
            siglaSistema: siglaSistema
          },
        ).pipe(
          map(
            data => {
              return data;
            },
          ),
          catchError(error => {
            return observableThrowError({ msg: 'CPF ou email incorretos' });
          }),
        );
      case 'GLOBAL': default:
        return this.http.post(RESET_PASSWORD_API_URL,
          {
            cpf: cpf,
            email: email,
            cpd:null,
          },
        ).pipe(
          map(
            data => {
              return true;
            },
          ),
          catchError(error => {
            return observableThrowError({ msg: 'CPF ou email incorretos' });
          }),
        );
    }
  }
}
